import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Link from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';
import MeasureQuickAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/MeasureQuickAppIcon';

import HelpArticleLink from 'components/Common/HelpArticleLink';

import MeasureQuickButton from '../OtherComponents/MeasureQuickButton';

const MeasureQuickStrategy = {
  previewInfo: {
    name: 'measureQuick',
    iconSvg: <MeasureQuickAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'measureQuick',
    category: 'Operations',
    details: (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography paragraph>
            measureQuick® is the one and only multi-brand wireless tool platform that can stream data, run diagnostics,
            and walk your dog at the same time (j/k, but it’s on their roadmap).
          </Typography>
          <Typography paragraph>
            It’s a comprehensive application that: collects measurements, aggregates data, diagnoses faults, analyzes
            and educates HVAC technicians, improves quality of work and eliminates unnecessary callbacks.
          </Typography>
          <div style={{ width: '100%', textAlign: 'center' }}>
            <img
              style={{ width: 620 }}
              alt="measureQuick logo"
              src="https://static-assets.housecallpro.com/app_store/apps/measurequick/gas_furnace.jpg"
            />
          </div>
          <Grid item xs={12}>
            <Typography style={{ fontWeight: 'bold' }}>Minimum measureQuick account requirements:</Typography>
          </Grid>
          <ul>
            <li>
              Company account must be setup in Virtuoso, which includes:
              <ul>
                <li>Address and phone number</li>
                <li>Technicians</li>
                <li>QBits added to the company account</li>
              </ul>
            </li>
            <li>Technicians need to have the measureQuick app downloaded and sign in.</li>
          </ul>
          <Grid item xs={12}>
            <Typography style={{ fontWeight: 'bold' }}>How it works</Typography>
          </Grid>
          <ul>
            <li>
              With an mQ admin account, log into{' '}
              <Link href="https://virtuoso.measurequick.com/">virtuoso.measurequick.com</Link>
              <ul>
                <li>Click on Company and Housecall Pro</li>
                <li>Click Connect with Housecall Pro</li>
                <li>Log into your Housecall Pro account</li>
                <li>Account is connected! Now you can match up your users</li>
              </ul>
            </li>
            <li>
              Your techs will now see a Open measureQuick button in the Housecall Pro app.
              <ul>
                <li>When selected, the measureQuick app will automatically open and a project will be started.</li>
                <li>
                  Tech will select which workflow and equipment they want, and will be prompted to unlock the project
                  for 5 QBits ($5) for a new piece of equipment.
                </li>
                <li>Tech will complete the work on the jobsite in measureQuick</li>
              </ul>
            </li>
            <li>
              Your tech can now generate a report in measureQuick and send it back to the job in HCP as an attachment
            </li>
          </ul>
          <Typography paragraph>
            For assistance with your measureQuick you can email{' '}
            <Link href="mailto:technical@measurequick.com">technical@measurequick.com</Link> or call{' '}
            <Link href="tel:234-813-9178">234-813-9178</Link>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography paragraph>
            Questions about this integration? Check out{' '}
            <HelpArticleLink helpArticlePath="/en/?q=measurequick">our help center here.</HelpArticleLink>
          </Typography>
        </Grid>
      </Grid>
    ),
    iconSvg: <MeasureQuickAppIcon size="xlarge" />,
  },
  sellingPoints: {},
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            + $5 per unit per year
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            + $5 per unit per year
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            + $5 per unit per year
          </Typography>
        </Grid>
      </Grid>
    ),
    hideToggle: true,
    appActionButton: <MeasureQuickButton />,
  },
  supportContacts: [
    { type: 'Phone', contact: '234-813-9178' },
    {
      type: 'Support',
      contact: <Link href="mailto:technical@measurequick.com">technical@measurequick.com</Link>,
    },
  ],
};

export default MeasureQuickStrategy;
